import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import PageNotFoundText from 'components/atoms/PageNotFoundText'
import SubmitButton from 'components/atoms/buttons/SubmitButton'

export const styles = theme => ({
  root: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  button: {
    marginTop: theme.spacing(3),
  },
})

const PageNotFound = ({ classes, buttonLabel, handleNavClick }) => (
  <div className={classes.root}>
    <div>
      <PageNotFoundText leftAlign />
      <SubmitButton
        size="large"
        color="primary"
        variant="primary"
        onClick={handleNavClick}
        className={classes.button}>
        {buttonLabel}
      </SubmitButton>
    </div>
  </div>
)

PageNotFound.propTypes = {
  buttonLabel: PropTypes.string,
  handleNavClick: PropTypes.func,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(PageNotFound)



// WEBPACK FOOTER //
// ./src/containers/account/PageNotFound/PageNotFound.js